import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images } from '../data/content';
const highlights = ['30 guided practices', '5 practice paths', '15 min or less', '6 premium volumes', '5 exclusive bonuses'];
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-8 sm:pb-20 sm:pt-12" data-id="element-163" data-mp="4na0yr7f9w7e">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-164" data-mp="129qwbqwlhzqi">
        <div className="flex items-center gap-2.5" data-id="element-165" data-mp="xanq434vpngy">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-800 text-gold-light" data-id="element-166" data-mp="xb5szim1qzxu">
            <SparklesIcon className="h-5 w-5" aria-hidden="true" data-id="element-167" data-mp="sde0onhhpbt4" />
          </span>
          <span className="font-serif text-lg font-bold text-brand-900 sm:text-xl" data-id="element-168" data-mp="nbosrgpkde99">Apometry Practice Deck™</span>
        </div>

        <p className="mt-5 rounded-full border border-brand-200 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-brand-700 sm:text-sm" data-id="element-169" data-mp="3cz5weevm861x">
          30 cards · 15 minutes a day
        </p>

        <h1 className="mt-5 font-serif text-[38px] font-bold leading-[1.08] text-ink sm:text-6xl" data-id="element-170" data-mp="3o7lqjmmw8ymu">
          Stop collecting techniques.{' '}
          <em className="block italic text-brand-700 sm:inline" data-id="element-171" data-mp="399bctsb4jly3">Start practicing.</em>
        </h1>

        <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-xl" data-id="element-172" data-mp="3e8ecex8c4zyo">
          A practical card-based system that gives you <strong className="text-ink" data-id="element-173" data-mp="30fya5yn9d5yt">a clear practice to follow</strong>{' '}
          whenever you don’t know what to do.
        </p>

        <ul className="mt-6 flex max-w-2xl flex-wrap justify-center gap-2" data-id="element-174" data-mp="2qkdcgcp82ruv">
          {highlights.map(h => <li key={h} className="rounded-full bg-brand-100 px-3 py-1.5 text-[13px] font-semibold text-brand-800 sm:text-sm" data-id="element-175" data-mp="2vi50gvmqxtts">
              {h}
            </li>)}
        </ul>

        <figure className="mt-8 w-full" data-id="element-176" data-mp="2lk8wcns87z56">
          <img src={images.deck} alt="The Apometry Practice Deck: 6 volumes, 30 guided practice cards, journal, checklist and calendar" className="mx-auto w-full max-w-2xl" data-id="element-177" data-mp="s1rpyhl8dur4" />
          <figcaption className="mt-2 font-serif text-lg font-semibold italic text-brand-800 sm:text-xl" data-id="element-178" data-mp="ibgmsx9dfpla">
            The 6 Volumes + 5 Bonuses of the Apometry Practice Deck™
          </figcaption>
        </figure>

        <div className="mt-8 w-full max-w-xl" data-id="element-179" data-mp="1azui3592s7t5">
          <CtaButton id="first-cta" label="I want my Apometry Practice Deck" data-id="element-180" data-mp="1ayjhfeaxfg69" />
          <p className="mt-3 text-sm text-muted" data-id="element-181" data-mp="162lyd08a3vps">
            Instant download · One-time payment of <strong className="text-ink" data-id="element-182" data-mp="11154hoo7p9ip">$27 USD</strong> · Lifetime access · 7-day
            guarantee
          </p>
          <Countdown data-id="element-183" data-mp="x37bearbm3a1" />
        </div>
      </div>
    </header>;
}